import { Alert, AlertIcon } from "@chakra-ui/react";

// keys
const ERROR_AMOUNT = "ERR_AMT";
const ERROR_AMOUNT_LESS_THAN_MIN = "ERR_AMT_LT_MIN";
const ERROR_AMOUNT_GREATER_THAN_MAX = "ERR_AMT_GT_MAX";
const ERROR_AMOUNT_NAN = "ERR_AMT_NAN";
const ERROR_LENGTH = "ERR_LEN";
const ERROR_LENGTH_LESS_THAN_MIN = "ERR_LEN_LT_MIN";
const ERROR_LENGTH_GREATER_THAN_MAX = "ERR_LEN_GT_MAX";
const ERROR_INSUFFICIENT_BALANCE = "ERR_BAL";
const ERROR_STREAM_EXISTS = "ERR_STREAM_EXISTS";

// messages dict
// TODO: internationalize and parametrize
const DCA_ERROR_MSGS = {
  ERR_AMT_NAN: "It's a numbers 🔢 game, brah!",
  ERR_AMT_LT_MIN: "Yo, help a brotha out, invest some more 💦.",
  ERR_AMT_GT_MAX: "Yo, chill brah, don't throw so much at us ☂️.",
  ERR_LEN_LT_MIN: "Gotta invest for the long term, plz make it longer 🍆, brah!",
  ERR_LEN_GT_MAX: "Too long, brah, plz make it shorter 📏!",
  ERR_STREAM_EXISTS: "You're already BTFDCA'ing this asset!",
};

// helpers for accessing the msgs
function getDcaErrorMessage(errKey) {
  return DCA_ERROR_MSGS[errKey];
}

function hasDcaErrors(errObj) {
  return Object.keys(errObj).length > 0;
}

// the component
function DcaConfigErrors({ dcaConfigErrors, ...props }) {
  let errMsgs = [];

  const errKeys = Object.keys(dcaConfigErrors);
  for (let idx in errKeys) {
    const errKey = errKeys[idx];
    const msg = getDcaErrorMessage(dcaConfigErrors[errKey]);
    if (msg) errMsgs.push(msg);
  }

  return (
    errMsgs.length > 0 && (
      <>
        {errMsgs.map((msg, idx) => {
          return (
            <Alert status="error" key={idx} py="1em" borderRadius="0.25em">
              <AlertIcon />
              {msg}
            </Alert>
          );
        })}
      </>
    )
  );
}

export {
  getDcaErrorMessage,
  ERROR_AMOUNT,
  ERROR_AMOUNT_LESS_THAN_MIN,
  ERROR_AMOUNT_GREATER_THAN_MAX,
  ERROR_AMOUNT_NAN,
  ERROR_LENGTH,
  ERROR_LENGTH_LESS_THAN_MIN,
  ERROR_LENGTH_GREATER_THAN_MAX,
  ERROR_INSUFFICIENT_BALANCE,
  ERROR_STREAM_EXISTS,
  DcaConfigErrors,
  hasDcaErrors,
};
